/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Installeddelta1Inputs */

const id_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan ukuran terpasang`)
};

const ms_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan saiz dipasang`)
};

const da_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændring i installeret størrelse`)
};

const de_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung der installierten Größe`)
};

const en_us2_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installed size change`)
};

const es_es2_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de tamaño instalado`)
};

const es_mx2_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de tamaño instalado`)
};

const fil_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbabago sa naka-install na laki`)
};

const fr_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variation de la taille installée`)
};

const it_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variazione delle dimensioni installate`)
};

const hu_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telepített méret változása`)
};

const nl_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijziging in geïnstalleerde grootte`)
};

const no_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endring i installert størrelse`)
};

const pl_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana zainstalowanego rozmiaru`)
};

const pt_br2_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração do tamanho instalado`)
};

const pt_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração do tamanho instalado`)
};

const ro_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificarea dimensiunii instalate`)
};

const fi_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asennetun koon muutos`)
};

const sv_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändring av installerad storlek`)
};

const vi_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi kích thước đã cài đặt`)
};

const tr_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüklü boyut değişikliği`)
};

const cs_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna instalované velikosti`)
};

const bg_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промяна в инсталирания размер`)
};

const ru_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера при установке`)
};

const uk_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміна встановленого розміру`)
};

const ar_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم المثبت`)
};

const hi_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंस्टॉल किए गए आकार में बदलाव`)
};

const th_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงขนาดที่ติดตั้ง`)
};

const ja_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インストールサイズの変化`)
};

const zh_cn2_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已安装大小变化`)
};

const zh_hant1_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已安裝大小變更`)
};

const ko_builds_comparison_installeddelta1 = /** @type {(inputs: Builds_Comparison_Installeddelta1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설치 크기 변경`)
};

/**
* | output |
* | --- |
* | "Installed size change" |
*
* @param {Builds_Comparison_Installeddelta1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_installeddelta1 = /** @type {((inputs?: Builds_Comparison_Installeddelta1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Installeddelta1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_installeddelta1(inputs)
	if (locale === "ms") return ms_builds_comparison_installeddelta1(inputs)
	if (locale === "da") return da_builds_comparison_installeddelta1(inputs)
	if (locale === "de") return de_builds_comparison_installeddelta1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_installeddelta1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_installeddelta1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_installeddelta1(inputs)
	if (locale === "fil") return fil_builds_comparison_installeddelta1(inputs)
	if (locale === "fr") return fr_builds_comparison_installeddelta1(inputs)
	if (locale === "it") return it_builds_comparison_installeddelta1(inputs)
	if (locale === "hu") return hu_builds_comparison_installeddelta1(inputs)
	if (locale === "nl") return nl_builds_comparison_installeddelta1(inputs)
	if (locale === "no") return no_builds_comparison_installeddelta1(inputs)
	if (locale === "pl") return pl_builds_comparison_installeddelta1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_installeddelta1(inputs)
	if (locale === "pt") return pt_builds_comparison_installeddelta1(inputs)
	if (locale === "ro") return ro_builds_comparison_installeddelta1(inputs)
	if (locale === "fi") return fi_builds_comparison_installeddelta1(inputs)
	if (locale === "sv") return sv_builds_comparison_installeddelta1(inputs)
	if (locale === "vi") return vi_builds_comparison_installeddelta1(inputs)
	if (locale === "tr") return tr_builds_comparison_installeddelta1(inputs)
	if (locale === "cs") return cs_builds_comparison_installeddelta1(inputs)
	if (locale === "bg") return bg_builds_comparison_installeddelta1(inputs)
	if (locale === "ru") return ru_builds_comparison_installeddelta1(inputs)
	if (locale === "uk") return uk_builds_comparison_installeddelta1(inputs)
	if (locale === "ar") return ar_builds_comparison_installeddelta1(inputs)
	if (locale === "hi") return hi_builds_comparison_installeddelta1(inputs)
	if (locale === "th") return th_builds_comparison_installeddelta1(inputs)
	if (locale === "ja") return ja_builds_comparison_installeddelta1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_installeddelta1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_installeddelta1(inputs)
	return ko_builds_comparison_installeddelta1(inputs)
});
export { builds_comparison_installeddelta1 as "builds.comparison.installedDelta" }